// extracted by mini-css-extract-plugin
module.exports = {"button":"startup-jobs_button__3WOtj","sending":"startup-jobs_sending__2uNo9"};